import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    orders: [],
    filteredOrders: [],
    orderModal: false,
    orderDetails: {},
    partnerAssignModal: false,
    deliveryPartners: [],
    selectedDeliveryPartner: "",
    loading: false,
    updatedDate: null,
    pendingOrders: [],
    assignedOrders: [],
    completedOrders: [],
    newdeliveryPartners: [],
    selectedDate: null,
    kioskOpen:false,
    ordersRefresh:false,
    // Stall filtering for FoodFix
    selectedStalls: [],
    showStallFilter: false,
    selectedCategories: [],
    foodfixCutoffTime: null,
    // Member batch filter: 'all' | 'member' | 'non_member'
    memberFilter: 'all',
    // Order status filter. 'all' keeps every status; anything else matches
    // Checkout.status exactly. Lives in redux beside memberFilter so it
    // survives paging and hub switches like the other filters do.
    statusFilter: 'all',
};


const orderReducer = createSlice({
    name: "orderReducer",
    initialState: initialState,
    reducers: {
        updateOrders: (state, { payload }) => {
            state.orders = payload;
        },
        updateOrderModel: (state, { payload }) => {
            state.orderModal = payload;
        },
        updateOrderDetails: (state, { payload }) => {
            state.orderDetails = payload;
        },
        updatePartnerAssignModal: (state, { payload }) => {
            state.partnerAssignModal = payload;
        },
        updateDeliveryPartners: (state, { payload }) => {
            state.deliveryPartners = payload;
        },
        updateNewDeliveryPartners: (state, { payload }) => {
            state.newdeliveryPartners = payload;
        },
        updateselectedDeliveryPartner: (state, { payload }) => {
            state.selectedDeliveryPartner = payload;
        },
        updatefilteredOrders: (state, { payload }) => {
            console.log("Updated Orders-----", payload);
            state.filteredOrders = payload;
        },
        updateLoading: (state, { payload }) => {
            state.loading = payload;
        },
        updateUpdatedDate: (state, { payload }) => {
            state.updatedDate = payload;
        },
        updatependingOrders: (state, { payload }) => {
            state.pendingOrders = payload;
        },
        updateassignedOrders: (state, { payload }) => {
            state.assignedOrders = payload;
        },
        updatecompletedOrders: (state, { payload }) => {
            state.completedOrders = payload;
        },
        updateSelectedDate: (state, { payload }) => {
            state.selectedDate = payload;
        },
        updateKioskOpen: (state, { payload }) => {
            state.kioskOpen = payload;
        },
        updateorderRefresh: (state, { payload }) => {
            state.ordersRefresh = payload;
        },
        updateSelectedStalls: (state, { payload }) => {
            state.selectedStalls = payload;
        },
        updateShowStallFilter: (state, { payload }) => {
            state.showStallFilter = payload;
        },
        updateSelectedCategories: (state, { payload }) => {
            state.selectedCategories = payload;
        },
        updateFoodfixCutoffTime: (state, { payload }) => {
            state.foodfixCutoffTime = payload;
        },
        updateStatusFilter: (state, { payload }) => {
            state.statusFilter = payload
        },
        updateMemberFilter: (state, { payload }) => {
            state.memberFilter = payload === 'member' || payload === 'non_member' ? payload : 'all';
        },
    }
});

export const {
    updateOrders,
    updateOrderModel,
    updateOrderDetails,
    updatePartnerAssignModal,
    updateDeliveryPartners,
    updateselectedDeliveryPartner,
    updatefilteredOrders,
    updateNewDeliveryPartners,
    updateLoading,
    updateUpdatedDate,
    updatependingOrders,
    updateassignedOrders,
    updatecompletedOrders,
    updateSelectedDate,
    updateKioskOpen,
    updateorderRefresh,
    updateSelectedStalls,
    updateShowStallFilter,
    updateSelectedCategories,
    updateFoodfixCutoffTime,
    updateMemberFilter,
    updateStatusFilter,
} = orderReducer.actions;

export default orderReducer.reducer;